/* @flow */

import React from 'react';
import EditoRenderer from 'edito/Render';

type Props = {
  content: CatalogPageContent,
};

const View = ({ content }: Props) => {
  return (
    <div>
      <EditoRenderer blocks={content.blocks || []} locked />
    </div>
  );
};

export default View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/flow/minimal/View.js